import shiwtchtyles from "../../../styles/UI/simpleSwitch.module.css";

export type Placement = "BEFORE" | "ABOVE" | "TAILING";

const Switch = ({
  id,
  checked,
  disabled,
  label,
  labelPlacement,
  onChange,
  width,
  height,
  uncheckedIcon,
  checkedIcon,
}: {
  id: string;
  checked: boolean;
  disabled?: boolean;
  labelPlacement?: Placement;
  label?: string;
  width?: number;
  height?: number;
  uncheckedIcon?: React.ReactNode;
  checkedIcon?: React.ReactNode;
  onChange: (checked: boolean) => void;
}) => {
  return (
    <label
      htmlFor={id}
      className={`${shiwtchtyles.switchWrapper} ${labelPlacement === "ABOVE" && "flex-col"}`}
    >
      <p>
        {(labelPlacement === "BEFORE" || labelPlacement === "ABOVE") && label}
      </p>

      <div
        className={shiwtchtyles.switch}
        style={{
          ...(width && { ["--switch-width" as any]: `${width}px` }),
          ...(height && { ["--switch-height" as any]: `${height}px` }),
        }}
      >
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />

        <span
          className={`${shiwtchtyles.slider} ${shiwtchtyles.round} ${
            disabled && shiwtchtyles.disabled
          }`}
        />

        {/* ICON MODE */}
        {checkedIcon && checked ? (
          <span
            className={`${shiwtchtyles.sliderCustomIcon} ${disabled && shiwtchtyles.disabled}`}
          >
            {checkedIcon}
          </span>
        ) : uncheckedIcon && !checked ? (
          <span
            className={`${shiwtchtyles.sliderCustomIcon} ${disabled && shiwtchtyles.disabled}`}
          >
            {uncheckedIcon}
          </span>
        ) : checked ? (
          <span
            className={`${shiwtchtyles.sliderCircleIconLine} ${disabled && shiwtchtyles.disabled}`}
          />
        ) : (
          <span
            className={`${shiwtchtyles.sliderCircleIconCircle} ${
              disabled && shiwtchtyles.disabled
            }`}
          />
        )}
      </div>

      {labelPlacement === "TAILING" && label}
    </label>
  );
};

export default Switch;
